import React from 'react';
import { Brands } from '../../models/brands';
import { formatCurrency } from '../../utils/common/numberUtils';
import { TipRules } from '../../models/tip';
import { BrandStyling } from '../../theme/brandStyling';

type TipButtonsProps = {
    brandId: Brands;
    currency: 'GBP' | 'EUR';
    serviceCharge?: number;
    tipRules?: TipRules;
};

const TipServiceCharge: React.FC<TipButtonsProps> = ({
                                                         serviceCharge,
                                                         currency,
                                                         brandId,
                                                         tipRules,
                                                     }) => {
    const styling = BrandStyling.byBrand(brandId);
    return (
        <div
            className='w-full group flex justify-center items-center pt-4 text-queen-blue'
        >
            <span className='flex gap-1'>
                <span className='font-semibold'>
                    +{formatCurrency(serviceCharge ?? 0, currency)}{' '}
                </span>
                processing fee
            </span>
            {styling.helpIcon}
            <span
                className={`absolute hidden group-hover:flex rounded text-left bg-white text-xs text-grey-carbon border translate-y-12 max-w-[272px] p-4 ${styling.tooltipStyle}`}
            >
                We charge{' '}
                {formatCurrency(tipRules?.standardChargeValue ?? 0, currency)}{' '}
                per tip, plus {tipRules?.enhancedTipPercentage}% of the tip
                amount on tips over{' '}
                {formatCurrency(
                    tipRules?.enhancedTipThresholdValue ?? 0,
                    currency,
                )}
            </span>
        </div>
    );
};

export default TipServiceCharge;
